import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import { ChangePasswordModel, CompanyModel } from '../../models/Company';

interface ICompanyService {
  getCompaniesByClient: (
    queryString: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CompanyModel[]>>;
  changePassword: (
    companyId: number,
    data: ChangePasswordModel,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  uploadCompanyLogo: (
    companyId: number,
    data: FormData,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
  deleteCompanyLogo: (
    companyId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<boolean>>;
}

export const companyService: ICompanyService = {
  getCompaniesByClient(queryString: string, axiosConfig) {
    return ajax.get<CompanyModel[]>(
      `${config.benefitApiUrl}/odata/companies${queryString}`,
      axiosConfig,
    );
  },
  changePassword(companyId: number, data: ChangePasswordModel, axiosConfig) {
    return ajax.patch(
      `${config.benefitApiUrl}/company/${companyId}/change-password`,
      data,
      axiosConfig,
    );
  },
  uploadCompanyLogo(companyId, data: FormData, axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/company/${companyId}/upload-logo`,
      data,
      axiosConfig,
    );
  },
  deleteCompanyLogo(companyId, axiosConfig) {
    return ajax.delete(
      `${config.benefitApiUrl}/company/${companyId}/delete-logo`,
      axiosConfig,
    );
  },
};
